import { useState } from 'react';

const useDropDown = ({ departments = [] }) => {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');

  const departmentsFilters = departments.filter(field => {
    const isMatch = field[0]?.toLowerCase().startsWith(search.toLowerCase());
    const isStatus = field[1] === status || status === '';
    if (isMatch && isStatus) {
      return field;
    }
    return null;
  });

  return {
    setSearch,
    setStatus,
    departmentsFilters,
  };
};

export default useDropDown;
